module.exports = __webpack_public_path__ + "img/sp_eyecatch01.716c27e5.jpg";